/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Nav_UsersInputs */

const en_admin_nav_users = /** @type {(inputs: Admin_Nav_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Users`)
};

const zh_admin_nav_users = /** @type {(inputs: Admin_Nav_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用户`)
};

/**
* | output |
* | --- |
* | "Users" |
*
* @param {Admin_Nav_UsersInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_nav_users = /** @type {((inputs?: Admin_Nav_UsersInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Nav_UsersInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_nav_users(inputs)
	return zh_admin_nav_users(inputs)
});
export { admin_nav_users as "admin.nav.users" }